//src/app/routes/AdminRoutes.tsx
import PromoCodesList from 'app/features/promoCodes/PromoCodesList';
import DashboardLayout from 'app/layout/dashboardLayout';
import { Route } from 'react-router-dom';
import { useAuth } from 'utils/AuthProvider';
import ProtectedRoutes from 'utils/ProtectedRoutes';
import AccountantsRoutes from './AccountantsRoutes';
import AnnouncementsRoutes from './AnnouncementsRoutes';
import ClientsRoutes from './ClientsRoutes';
import DocumentsRoutes from './DocumentsRoutes';
import HomeRoute from './HomeRoute';
import MessagesRoutes from './MessagesRoutes';
import NotificationsRoutes from './NotificationsRoutes';
import ProjectsRoutes from './ProjectsRoutes';
import Questionnaires from 'app/features/questionnaires';
import CreateQuestionnaire from 'app/features/questionnaires/create';
import ShowQuestionnaire from 'app/features/questionnaires/show';
import ServicesRoutes from './ServicesRoutes';
import TaskRoutes from './TaskRoutes';
import TaxEstimatesRoutes from './TaxEstimatesRoutes';
import TaxExtensionsRoutes from './TaxExtensionsRoutes';
import TicketsRoutes from './TicketsRoutes';
import UpcomingDatesRoutes from './UpcomingDatesRoutes';
import BillingRoutes from './BillingRoutes';
import Payments from 'app/features/payments';
import CardSuccess from 'app/features/payments/redirectionPages/cardSuccess';
import PaymentFailed from 'app/features/payments/redirectionPages/paymentFailed';
import PaymentSuccessful from 'app/features/payments/redirectionPages/paymentSuccessful';
import LinkedInCallback from 'Components/LinkedIn/LinkedInCallback';
import FincenReportsRoutes from './FincenReportsRoutes';
import QuickBooksCallback from 'Components/Quickbooks/QuickbooksCallback'; // Import the IntegrationRoutes
import ControlServicesRoutes from './ControlServicesRoutes';
import TimesheetRoutes from './TimesheetRoutes';
import JournalEntriesRoutes from './JournalEntriesRoutes';
import AccountsRoutes from './AccountsRoutes';
export default function AdminRoutes() {
  const { isAdmin } = useAuth();
  if (!isAdmin) return null;

  return (
    <>
      <Route path="/linkedin/callback" element={<LinkedInCallback />} />{' '}
      <Route path="/quickbooks/callback" element={<QuickBooksCallback />} />
      {/* Move this outside of dashboard */}
      <Route element={<ProtectedRoutes user="ADMIN" />}>
        <Route
          path="/dashboard"
          element={<DashboardLayout internalPadding={false} />}
        >
          {HomeRoute()}
          <Route path="promocodes" element={<PromoCodesList />} />
          {NotificationsRoutes()}
          <Route path="questionnaires">
            <Route index element={<Questionnaires />} />
            <Route path="create" element={<CreateQuestionnaire />} />
            <Route
              path=":questionnaireId/download"
              element={<ShowQuestionnaire preview />}
            />
            <Route
              path=":questionnaireId/preview"
              element={<ShowQuestionnaire preview />}
            />
            <Route path=":questionnaireId/*" element={<ShowQuestionnaire />} />
          </Route>
          {ProjectsRoutes()}
          {AccountsRoutes()}
          {JournalEntriesRoutes()}
          {DocumentsRoutes()}
          {TaxEstimatesRoutes()}
          {TaxExtensionsRoutes()}
          {TaskRoutes()}
          {TimesheetRoutes()}
          {ClientsRoutes()}
          {AccountantsRoutes()}
          {MessagesRoutes()}
          {TicketsRoutes()}
          {ServicesRoutes()}
          {ControlServicesRoutes()}
          {AnnouncementsRoutes()}
          {UpcomingDatesRoutes()}
          {BillingRoutes()} {/* Use the BillingRoutes here */}
          {FincenReportsRoutes()}
          <Route path="payments" element={<Payments />} />
          <Route path="payments/add-card/success" element={<CardSuccess />} />
          <Route path="payments/payment-failed" element={<PaymentFailed />} />
          <Route
            path="payments/payment-success"
            element={<PaymentSuccessful />}
          />
        </Route>
      </Route>
    </>
  );
}
